export const PROD = true;

export let BASE_URL = PROD
  ? `https://api.technowren.com`
  : `http://localhost:5001`;
